<template>
  <grid-test
    has-edit
    has-delete
    has-checkbox
    has-pagination
    grid-id="company-grid"
    :checked-row-item-ids.sync="checkedRowItemIds"
    :fields="fields"
    :items="companies"
    :get-items-function="getCompanies"
    :filters="filtersObjArr"
    :total-rows="paging.totalItems"
    :current-page="paging.pageNumber"
    :per-page="paging.pageSize"
    :sort-by="paging.sortBy"
    :sort-order="paging.sortOrder"
    @edit="onEdit"
    @delete="onDelete"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex';

import GridTest from '@/shared/components/GridTest';

import fields from '../../fields';

export default {
  components: {
    GridTest,
  },
  data() {
    return {
      fields: fields,
      filtersObjArr: [],
      formSelect: {
        companyStatusValues: [],
        companyRoles: [],
        submittedByArr: [],
        companyAttributes: [],
      },
      checkedRowItemIds: [],
    }
  },
  computed: {
    ...mapState('companies', [
      'paging',
      'companies',
      'companyStatusValues',
      'companyRoles',
      'submittedByArr',
      'companyAttributes',
    ]),
  },
  methods: {
    ...mapActions('companies', [
      'getCompanies',
      'getCompanyStatusValues',
      'getCompanyRoles',
      'getSubmittedBy',
      'getCompanyAttributes',
    ]),
    convertToFormSelectObj(arr, { value, text }) {
      const convertedObjArr = [];

      arr.forEach((a) => {
        convertedObjArr.push({ value: a[value], text: a[text] });
      });

      return convertedObjArr;
    },
    onEdit() {
      alert('clicked on edit button');
    },
    onDelete() {
      alert('clicked on delete button');
    },
  },
  async created() {
    // Get lookup values
    await this.getCompanyStatusValues();
    await this.getCompanyRoles();
    await this.getSubmittedBy();
    await this.getCompanyAttributes();

    // Convert lookups to correct format for form <select>
    this.formSelect.companyStatusValues = this.convertToFormSelectObj(
      this.companyStatusValues, { value: 'id', text: 'val' }
    );
    this.formSelect.companyRoles = this.convertToFormSelectObj(
      this.companyRoles, { value: 'id', text: 'companyRole' }
    );
    this.formSelect.submittedByArr = this.convertToFormSelectObj(
      this.submittedByArr, { value: 'id', text: 'fullName' }
    );
    this.formSelect.companyAttributes = this.convertToFormSelectObj(
      this.companyAttributes, { value: 'id', text: 'attributeName' }
    );

    this.filtersObjArr = [
      { type: 'search', name: 'Company Name', fieldName: 'companyName' },
      { type: 'select', name: 'Status', fieldName: 'status', options: this.formSelect.companyStatusValues },
      { type: 'select', name: 'Role', fieldName: 'role', options: this.formSelect.companyRoles },
      { type: 'select', name: 'Is Verified?', fieldName: 'verified', options: [
          { value: null, text: 'All' },
          { value: 1, text: 'Yes' },
          { value: 0, text: 'No' },
        ] 
      },
      { type: 'select', name: 'Submitted By', options: this.formSelect.submittedByArr },
      { type: 'select', name: 'Attributes', fieldName: 'attribute', options: this.formSelect.companyAttributes },
    ];

    Object.keys(this.paging.filters).forEach((key, index) => {
      this.$set(this.filtersObjArr[index], 'value', this.paging.filters[key]); // Set to Vuex value
    });
  },
}
</script>